import { Information, Tag } from '@lmc/ui-kit'
import { Heading, Text } from '@lmc/ui-kit/src/general'
import { Spinner } from 'components/generic'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type NeedsAssignedProps = {
  name?: string
  tags?: string[]
  isLoading?: boolean
}

const NeedsAssigned: FC<NeedsAssignedProps> = ({ name, tags, isLoading }) => {
  const { t } = useTranslation()

  const hasTags = !!tags?.length

  return (
    <CardContainer>
      <HeaderRowContainer>
        <Information />
        <FormCardHeading level={4}>
          {t('NEEDS_ASSIGNED', { variable: name })}
        </FormCardHeading>
      </HeaderRowContainer>
      {!isLoading && hasTags && (
        <TagsWrapper>
          {tags?.map((tag) => (
            <Tag>
              <StyledText level={2}>{tag}</StyledText>
            </Tag>
          ))}
        </TagsWrapper>
      )}
      {!isLoading && !hasTags && (
        <StyledText>{t('NO_NEEDS_ASSIGNED')}</StyledText>
      )}
      {isLoading && <Spinner style={{ paddingTop: 0 }} />}
    </CardContainer>
  )
}

export default NeedsAssigned

const TagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px 0px;
  flex-wrap: wrap;
`

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const CardContainer = styled.div`
  padding: 24px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  border: 1px solid;
  border-color: ${({ theme }) => theme.color.neutral.color8};
`

const HeaderRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

const FormCardHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
`
